var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('menu-pages',_vm._b({staticClass:"ce-menu-abstract",scopedSlots:_vm._u([{key:"link",fn:function(ref){
var link = ref.link;
return [(link.data && link.data.abstract)?_c('html-parser',{attrs:{"content":link.data.abstract}}):_vm._e()]}}])},'menu-pages',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }